<template>
  <div class="messageCenter">
    <div class="tabs">
      <ul class="role-auth-title">
        <li :class="{ active: businessType == 0 }" @click="chooseType(0)">
          系统资源
        </li>
        <li :class="{ active: businessType == 1 }" @click="chooseType(1)">
          项目资源
        </li>
      </ul>
    </div>
    <div class="body">
      <div class="top">
        <el-form inline class="form" size="small" style="float: right">
          <el-form-item>
            <el-button type="primary" size="small" :disabled="isDisabled" @click="submitModulesHandler()">
              提交权限
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchName" size="small" placeholder="请输入资源名称">
              <i slot="suffix" class="el-icon-search el-input__icon" />
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-switch
              v-model="permissionKeyShow"
              title="显示权限标识">
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div v-loading="tableLoading" class="table" element-loading-text="数据加载中...">
        <el-table row-key="permissionId" :indent="16" :tree-props="moduleTreeProp" height="100%" :data="moduleTreeData"
          :show-header="false" default-expand-all border :cell-style="cellStyle">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size:16px;color:#000;">
              暂无数据
            </p>
          </template>
          <el-table-column class-name="table-module-name" width="260px" show-overflow-tooltip>
            <template #default="{ row }">
              <span>
                <el-checkbox v-model="row.isChecked" :true-label="1" :false-label="0" :indeterminate="getIndeterminate(row)"
                  @change="setTreeLimit(row)">
                </el-checkbox>
                {{ row.permissionName }}<span v-if="permissionKeyShow">({{ row.permissionKey }})</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column class-name="table-module-btnname">
            <template #default="{ row }">
              <div v-for="(item, index) in row.buttonList" :key="index" style="margin-right: 30px">
                <el-checkbox v-model="item.isChecked" :true-label="1" :false-label="0" @change="checkboxChange(item)">
                  {{ item.permissionName }}<span v-if="permissionKeyShow">({{ row.permissionKey }})</span>
                </el-checkbox>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import role from "@/CommonDP/service/admin/role-service";
import { STATIC } from "@/CommonDP/utils";
import { getTreeData } from "@/CommonDP/utils/tree";
import { mapState } from "vuex";
export default {
  name: "AdminPermisson",
  data () {
    return {
      businessType: 0,
      tableLoading: false,
      zanwu: STATIC + "/images/暂无数据.png",
      moduleTreeProp: {
        children: "childList"
      },
      moduleTree: [],
      initModuleTree: [], // 右侧初始获得的模块树
      searchName: '',
      permissionKeyShow: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    // 模块扁平化
    flatModuleList () {
      const { moduleTree } = this;
      const list = [];
      const each = (childList) => {
        for (const module of childList) {
          list.push(module);
          const { childList } = module;
          if (childList && childList.length > 0) each(childList);
        }
      };
      each(moduleTree);
      return list;
    },
    // 按钮扁平化
    flatModuleButtonList () {
      const { moduleTree } = this;
      const list = [];
      const each = (childList) => {
        for (const module of childList) {
          if (module.buttonList.length > 0) {
            module.buttonList.forEach(ele => {
              list.push(ele);
            });
          }
          const { childList } = module;
          if (childList && childList.length > 0) each(childList);
        }
      };
      each(moduleTree);
      return list;
    },
    // 判断是否与原数据发生变化2
    submitList () {
      const newarr = [];
      this.getTreeDataByFilter(this.moduleTree, newarr);
      return newarr;
    },
    // 判断是否与原数据发生变化1
    isDisabled () {
      return JSON.stringify(this.initModuleTree) === JSON.stringify(this.submitList);
    },
    // 搜索
    moduleTreeData() {
      const { searchName, moduleTree } = this;
      const searchValue = searchName;
      const moduleTreeList = moduleTree;
      if (searchValue) {
        const handleTreeData = this.handleTreeData(moduleTreeList, searchValue);
        return handleTreeData;
      }
      return moduleTree;
    }
  },
  created () {
    this.getModuleList(0);
  },
  methods: {
    //  树形表格过滤
    handleTreeData(treeData, searchValue) {
      if (!treeData || treeData.length === 0) {
        return [];
      }
      const array = [];
      for (let i = 0; i < treeData.length; i += 1) {
        let match = false;
        for (const pro in treeData[i]) {
          if (pro === "permissionName" || pro === "permissionKey") {
            if (typeof treeData[i][pro] === "string") {
              match |= treeData[i][pro].includes(searchValue);
              if (match) break;
            }
          }
        }
        const childListLength = this.handleTreeData(treeData[i].childList, searchValue).length;
        const buttonListLength = this.handleTreeData(treeData[i].buttonList, searchValue).length;
        if (childListLength > 0 || buttonListLength > 0 || match) {
          array.push({
            ...treeData[i],
            childList: this.getchildList(treeData[i], searchValue),
            buttonList: this.getbuttonList(treeData[i], searchValue)
          });
        }
      }
      return array;
    },
    getchildList(data, searchValue) {
      if (data.resourceType === 0) {
        return this.handleTreeData(data.childList, searchValue);
      }
    },
    getbuttonList(data, searchValue) {
      if (data.pid === '0') {
        return data.buttonList;
      } else if (data.resourceType === 0) {
        return data.buttonList;
      } else if (data.resourceType === 1) {
        return this.handleTreeData(data.buttonList, searchValue);
      }
    },
    chooseType (key) {
      this.businessType = key;
      this.getModuleList(key);
    },
    getIndeterminate (row) {
      const { childList, isChecked } = row;
      if (childList && childList.length > 1) {
        for (const item of childList) {
          if (item.isChecked !== isChecked) return true;
        }
      }
      return false;
    },
    // 修改模块和子元素可见性
    setTreeLimit (row) {
      const { setChildrenLimit, setParentLimit, flatModuleList } = this;
      const module = flatModuleList.find(({ permissionId }) => row.permissionId === permissionId);
      module.isChecked = row.isChecked;
      const { isChecked, permissionId, pid } = row;
      setChildrenLimit(permissionId, isChecked);
      setParentLimit(pid, isChecked);
    },
    // 修改按钮和子元素可见性
    checkboxChange (row) {
      const { setbuttonParentLimit, flatModuleButtonList } = this;
      const module = flatModuleButtonList.find(({ permissionId }) => row.permissionId === permissionId);
      module.isChecked = row.isChecked;
      const { isChecked, pid } = row;
      setbuttonParentLimit(pid, isChecked);
    },
    setChildrenLimit (permissionId, isChecked) {
      const { flatModuleList, setChildrenLimit } = this;
      const module = flatModuleList.find((module) => permissionId === module.permissionId);
      if (module && module.childList && module.childList.length > 0) {
        for (const item of module.childList) {
          item.isChecked = isChecked;
          setChildrenLimit(item.permissionId, isChecked);
        }
      } else if (module && module.buttonList && module.buttonList.length > 0) {
        for (const item of module.buttonList) {
          item.isChecked = isChecked;
          setChildrenLimit(item.permissionId, isChecked);
        }
      }
    },
    setParentLimit (pid, isChecked) {
      if (pid === "0" || !pid) return;
      const { setParentLimit, flatModuleList } = this;
      const module = flatModuleList.find(({ permissionId }) => pid === permissionId);
      if (module && module.childList) {
        // 子元素全部不显示或者有显示的
        let hasShow = false;
        for (const item of module.childList) {
          if (item.isChecked > 0) hasShow = true;
        }
        if ((hasShow && isChecked > 0) || (!hasShow && isChecked < 1)) {
          if (module.isChecked !== isChecked) {
            module.isChecked = isChecked;
            setParentLimit(module.pid, isChecked);
          }
        }
      }
    },
    setbuttonParentLimit (pid, isChecked) {
      if (pid === "0" || !pid) return;
      const { flatModuleList, setParentLimit } = this;
      const module = flatModuleList.find(({ permissionId }) => pid === permissionId);
      if (module && module.buttonList && module.isChecked == 0) {
        // 子元素全部不显示或者有显示的
        let hasShow = false;
        for (const item of module.buttonList) {
          if (item.isChecked > 0) hasShow = true;
        }
        if ((hasShow && isChecked > 0) || (!hasShow && isChecked < 1)) {
          if (module.isChecked !== isChecked) {
            module.isChecked = isChecked;
            setParentLimit(module.pid, isChecked);
          }
        }
      }
    },
    getModuleList (key) {
      this.tableLoading = true;
      const { enterpriseId } = this;
      role.queryPermissionTreeForAssign(key, enterpriseId).then(({ data }) => {
        this.moduleTree = data || [];
        getTreeData(this.moduleTree);
        this.tableLoading = false;
        var list = [];
        this.getTreeDataByFilter(this.moduleTree, list);
        this.initModuleTree = JSON.parse(JSON.stringify(list));
      });
    },

    // 提交已修改模块树
    async submitModulesHandler () {
      const list = this.moduleTree;
      var newarr = [];
      this.getTreeDataByFilter(list, newarr);
      const rolePermissionDetailList = newarr.map((item) => {
        return {
          permissionId: item.permissionId,
          isParentPage: item.isParentPage
        };
      });
      const params = {
        enterpriseId: this.enterpriseId,
        rolePermissionDetailList,
        businessType: this.businessType
      };
      const res = await role.addPermissionEnterprise(params);
      if (res.result == 0) this.$message.success("保存成功");
      this.getModuleList(this.businessType);
    },
    getTreeDataByFilter (data, newarr) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].isChecked == 0) {
          newarr.push({
            permissionId: data[i].permissionId,
            isParentPage: data[i].isParentPage
          });
        }
        if (data[i].childList && data[i].childList.length > 0) {
          this.getTreeDataByFilter(data[i].childList, newarr);
        } // 原版这里是else if 因为有些父级既有childList也有buttonList所以改成if
        if (data[i].buttonList && data[i].buttonList.length > 0) {
          this.getTreeDataByFilter(data[i].buttonList, newarr);
        }
      }
      return newarr;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return "background: #F7F9FF";
      }
    },
    changePermissionKeyShow() {
      this.permissionKeyShow = !this.permissionKeyShow;
    }
  }
};
</script>
<style lang="scss">
.form {
  .el-form-item {
    margin-bottom: 0;
  }
}
.table-module-name{
  .cell {
    white-space:pre
  }
}
.table-module-btnname {
  .cell {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    overflow: hidden;
  }
}
</style>
<style lang="scss" scoped>
.messageCenter {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 700px;
  .tabs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #ebefff;

    /deep/.el-badge__content {
      z-index: 1;
    }

    /deep/.el-radio-button__inner {
      padding: 10px 30px;
    }

    .role-auth-title {
      display: flex;
      padding: var(--small-space) var(--big-space);

      li {
        line-height: 36px;
        margin-right: 30px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
      }
      .active {
        border-bottom: 2px solid var(--theme-color);
        box-sizing: border-box;
        color: var(--theme-color);
      }
    }
  }
  .body {
    height: calc(100% - 70px);
    background-color: #fff;
    padding-bottom: 10px;
    position: relative;

    .top {
      padding: var(--middle-space) var(--big-space) 0;
    }

    .table {
      position: absolute;
      padding: 0 var(--big-space);
      left: 0;
      right: 0;
      bottom: 40px;
      top: calc(32px + var(--middle-space) * 2);
    }
  }
  .el-table>>>.warm-row {
    color: #ccc;
  }
  ::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
    td:first-child {
      padding-left: 23px;
    }
  }
}
</style>
